import { apiFetch } from '../lib/api';
import type { MatchSource } from './vehicles';

export interface BoltPatternPreview {
  raw: string;
  normalized: string;
  canonical: string;
  via: MatchSource;
}

export interface PreviewResponse {
  success: boolean;
  patterns: BoltPatternPreview[];
  errors: string[];
}

export function previewBoltPattern(raw: string): Promise<PreviewResponse> {
  return apiFetch('/admin/bolt-patterns/preview', {
    method: 'POST',
    body: JSON.stringify({ raw }),
  });
}
